<template>
  <v-content class="pt-3 pb-0">
    <v-container fluid grid-list-md class="pa-0">
      <v-layout row wrap>
        <v-flex sm6>
          <v-text-field
            label="Name"
            v-model="p.payerName"
            :error-messages="payerNameErrors"
            required
            @input="$v.p.payerName.$touch()"
            @blur="$v.p.payerName.$touch()"
            :outlined="outlinedInputs"
          ></v-text-field>
        </v-flex>
        <v-flex sm6>
          <v-text-field
            label="Surname"
            v-model="p.payerSurname"
            :error-messages="payerSurnameErrors"
            required
            @input="$v.p.payerSurname.$touch()"
            @blur="$v.p.payerSurname.$touch()"
            :outlined="outlinedInputs"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex sm6>
          <v-text-field
            label="Amount"
            v-model.number="p.amount"
            :error-messages="amountErrors"
            @input="$v.p.amount.$touch()"
            @blur="$v.p.amount.$touch()"
            :outlined="outlinedInputs"
          ></v-text-field>
        </v-flex>
        <v-flex sm6>
          <currency-list-select
            :currencyCode="p.currencyCode"
            @onSelect="onSelectCurrency"
            :outlined="outlinedInputs"
          ></currency-list-select>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex sm6>
          <v-text-field
            disabled
            label="Reference"
            v-model="p.itineraryReference"
            :outlined="outlinedInputs"
          ></v-text-field>
        </v-flex>
        <v-flex sm6>
          <v-select
            :items="paymentTypes"
            label="Payment Type"
            v-model="p.type"
            :outlined="outlinedInputs"
          ></v-select>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex sm6>
          <date-picker
            :resetDate="newDialog"
            :customLabel="dateLabel"
            @onDateSelected="onDateSelected"
            :gtDateString="p.lodgementDate"
            :outlined="outlinedInputs"
          ></date-picker>
        </v-flex>
        <v-flex sm6>
          <v-text-field
            label="Exchange Rate"
            v-model.number="p.exchangeRate"
            :outlined="outlinedInputs"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex sm12>
          <v-textarea
            label="Notes"
            v-model="p.notes"
            :outlined="outlinedInputs"
          ></v-textarea>
        </v-flex>
      </v-layout>
    </v-container>
    <div v-if="debug">{{ p }}</div>
  </v-content>
</template>

<script>
import CurrencyListSelect from "../../shared/CurrencyListSelect";
import DatePicker from "../../shared/DatePicker";
import { required } from "vuelidate/lib/validators";
import { NumberValidator } from "../../../../helpers/validators/simple-validators";
let moment = require("moment");
export default {
  props: {
    payment: {
      type: Object,
    },
    context: {
      type: String,
      default: "default_context",
    },
    newDialog: {
      type: Boolean,
      default: false,
    },
  },

  components: {
    DatePicker,
    CurrencyListSelect,
  },

  data() {
    return {
      debug: false,
      p: { ...this.payment },
      paymentTypes: [
        "Cash",
        "Transfer",
        "Credit Card",
        "Cheque",
        "CC To Supplier",
        "Agent Commission Payment",
        "Agent Commission Paid",
        "Agent Refund",
        "Other",
      ],
      dateLabel: "Lodgement Date",
    };
  },

  computed: {
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    payerNameErrors() {
      var errors = [];
      if (!this.$v.p.payerName.$dirty) return errors;
      !this.$v.p.payerName.required && errors.push("Payer name is required.");
      return errors;
    },
    payerSurnameErrors() {
      var errors = [];
      if (!this.$v.p.payerSurname.$dirty) return errors;
      !this.$v.p.payerSurname.required &&
        errors.push("Payer surname is required.");
      return errors;
    },
    amountErrors() {
      var errors = [];
      if (!this.$v.p.amount.$dirty) return errors;
      !this.$v.p.amount.NumberValidator &&
        errors.push("Amount must be a numeric value.");
      return errors;
    },
  },

  watch: {
    payment: function (data) {
      this.p = { ...data };
      if (data.lodgementDate != null) {
        this.lodgementDate = data.lodgementDate;
      }
    },
    newDialog: function (val) {
      if (val == true) {
        this.p = { ...this.payment };
        this.$v.p.$reset();
      }
    },
  },

  methods: {
    onSelectCurrency(data) {
      this.p.currencyCode = data;
    },
    onDateSelected(data) {
      this.p.lodgementDate = data;
    },
  },

  validations: {
    p: {
      payerName: { required },
      payerSurname: { required },
      amount: { NumberValidator },
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/gt/finances/payments/PaymentEditorDetails.vue